<template>
  <div class="header">
    <div class="header-inner">
      <div class="header-logo">
        <h1 @click="onLogoClick"><img src="@/assets/logo/logo.png" alt="企鹅号小店" title="企鹅号小店" width="98" /></h1>
        <h2>{{ subTitle }}</h2>
      </div>

      <!-- 登录后的管理端内页 [[ -->
      <div v-if="isManagePage" class="header-menu">
        <div class="header-menu__item link header-menu__item--msg" @click="showMsgDialog">
          <i class="header-menu__item-ico el-icon-message" />
          <div class="header-msg-link">
            消息中心
            <span v-show="totalUnreadMsg > 0" class="header-msg-number">
              {{ totalUnreadMsgText }}
            </span>
          </div>
        </div>

        <!-- 消息提醒气泡 [[ -->
        <msg-bubble
          class="header-msg-bubble"
          :is-show="totalUnreadMsg > 0"
          :msg-bubble-text="`${totalUnreadMsgText} 消息未读`"
        />
        <!-- ]] 消息提醒气泡 -->

        <!-- 消息弹层 -->
        <msg-dialog ref="msgDialog" />
        <!-- 消息弹层结束 -->

        <a class="header-menu__item link" :href="guideDocLink" target="_blank">
          <i class="header-menu__item-ico el-icon-notebook-2" />
          <span>操作指引</span>
        </a>

        <a class="header-menu__item link" href="https://support.qq.com/product/326185" target="_blank">
          <i class="header-menu__item-ico el-icon-chat-dot-round" />
          <span>问题反馈</span>
        </a>

        <div class="header-menu__item header-menu__item--user">
          <i class="header-menu__item-ico user-avatar" :style="'background-image:url(' + avatar + ')'" />
          <span>{{ username }}</span>
        </div>

        <div class="header-menu__item header-menu__item--logout">
          <span class="ui-link" @click="handleLogout">退出</span>
        </div>
      </div>
      <!-- ]] 登录后的管理端内页 -->

      <!-- 未登录的管理端外页（登录页、注册页等） [[ -->
      <div v-else class="header-menu">
        <a class="header-menu__item link" :href="guideDocLink" target="_blank">
          <i class="header-menu__item-ico el-icon-notebook-2" />
          <span>操作指引</span>
        </a>
      </div>
      <!-- ]] 未登录的管理端外页（登录页、注册页等） -->
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import { Helper } from '@/lib/helper';
import { config } from '@/config/index';
import MsgBubble from './msg-bubble';
import MsgDialog from './msg-dialog';
import avatar from '@/assets/layout/default_avatar.png';

export default {
  name: 'EbHeader',
  components: {
    MsgBubble,
    MsgDialog,
  },
  props: {
    subTitle: {
      type: String,
      default: '管理平台',
    },
    userType: {
      type: String,
      default: 'talent', // talent, 达人, 默认值 | supplier, 供货商； 登录页需要
    },
    isManagePage: {
      type: Boolean,
      default: false, // 是否登录后的管理端页面
    },
    isLoginPage: {
      type: Boolean,
      default: false, // 是否登录页
    },
  },
  data() {
    return {
      defaultAvatar: avatar,
      skip: false,
      isdisabled: true,
      inviteCode: '',
    };
  },
  computed: {
    ...mapState('messageCenter', ['totalUnreadMsg']),
    ...mapState('userCenter', {
      profile: state => state.profile,
    }),

    totalUnreadMsgText() {
      return this.totalUnreadMsg <= 99 ? this.totalUnreadMsg : '99+';
    },
    username() {
      return this.profile.phone || this.profile.uid;
    },
    avatar() {
      return this.profile.avatar_url || this.defaultAvatar;
    },
    guideDocLink() {
      if (this.isLoginPage && this.userType === 'talent') return 'https://docs.qq.com/doc/DTk1HSERrTlFuZ3N3';
      if (this.isLoginPage && this.userType === 'supplier') return 'https://docs.qq.com/doc/DTnFaS2Njck1RSXBi';

      return 'https://docs.qq.com/doc/DTmV6dkh6cUd1WFlD';
    },
  },
  methods: {
    onLogoClick() {
      if (this.isManagePage) {
        this.$router.push('/userCenter');
      } else {
        this.$router.push('/welcome');
      }
    },
    handleLogout() {
      Helper.removeLoginInfo();
      window.location.href = config.loginUrl;
      this.$emit('logout');
    },
    // 跳转问题反馈页面
    toFeedback() {
      window.open('https://support.qq.com/product/326185');
    },
    // 显示msg弹框
    showMsgDialog() {
      this.$refs.msgDialog.showDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
@contentMaxWidth: var(--ui-page-min-width); /* 内容最大宽度 */

.header {
  height: 64px;
  background-color: #FFFFFF;
  box-shadow: var(--ui-box-shadow);
  padding-right: 8px; /* 内容区有8px的竖滚动条，否则对不齐 */
  position: relative;
  z-index: 1;
}
.header-inner {
  max-width: @contentMaxWidth;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.header-logo {
  display: flex;
  margin-left: 20px;

  h1 {
    cursor: pointer;
  }
  h2 {
    color: var(--ui-base-font-color);
    font-size: 18px;
    font-weight: 400;
  }
  h2::before {
    content: "";
    display: inline-block;
    height: 13px;
    width: 1px;
    background-color: #CDCDCD;
    margin: 0 10px;
  }
}
.header-menu {
  position: relative;
  height: 100%;
  display: flex;
  margin-right: 20px;
  font-size: 14px;
}
.header-menu__item {
  padding: 0 16px;
  height: 100%;
  display: flex;
  align-items: center;

  &.link {
    color: inherit;
    text-decoration: none;
  }
  &.link:hover {
    cursor: pointer;
    color: var(--ui-main-color);
    background-color: var(--ui-bg-color);
  }
}
.header-menu__item--logout {
  padding-right: 0;
}
.header-menu__item--user .user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-size: cover;
  margin-right: 10px;
}
.header-menu__item-ico {
  font-size: 16px;
  margin-right: 6px;
}
.header-msg-link {
  position: relative;
}
.header-msg-number {
  position: absolute;
  right: -26px;
  top: -8px;
  background-color: #e34d59;
  height: 16px;
  line-height: 16px;
  border-radius: 8px;
  color: #ffffff;
  font-size: 12px;
  width: 28px;
  text-align: center;
}
.header-msg-bubble {
  left: -30px;
}
</style>

